import React, { useContext } from "react";

/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import OrderList from "./components/Dashboard/OrderList";
import Event from "./components/Dashboard/Event";
import CustomerList from "./components/Dashboard/CustomerList";
import Analytics from "./components/Dashboard/Analytics";
import Reviews from "./components/Dashboard/Reviews";
import Task from "./components/Dashboard/Task";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// CMS Pages
import Content from "./components/Cms/Content";
import Menu from "./components/Cms/Menu";
import EmailTemplate from "./components/Cms/EmailTemplate";
import Blog from "./components/Cms/Blog";

import ContentAdd from "./components/Cms/ContentAdd";
import AddMail from "./components/Cms/AddMail";
import AddBlog from "./components/Cms/AddBlog";
import BlogCategory from "./components/Cms/BlogCategory";

//Icons
import FlatIcons from "./components/Icons/FlatIcons";
import FeatherIcons from "./components/Icons/FeatherIcons";
import SvgIcons from "./components/Icons/SvgIcons";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import MediaObject from "./components/bootstrap/MediaObject";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

//Redux
import Todo from "./pages/Todo";

/// Widget
import Widget from "./pages/Widget";

/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import DataTable from "./components/table/DataTable";
import BootstrapTable from "./components/table/BootstrapTable";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import Pickers from "./components/Forms/Pickers/Pickers";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages
import LockScreen from "./pages/LockScreen";
import EmptyPage from "./components/Dashboard/EmptyPage";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";

import { ThemeContext } from "../context/ThemeContext";
import Audience from "./pages/Audience";
import CustomForm from "./pages/Audience/form";
import CustomGroupForm from "./pages/Audience/group-form";
import Venue from "./pages/Venue";
import Initiative from "./pages/Initiative";
import PerformanceVenues from "./pages/PerformanceVenues";
import AddUpdate from "./pages/Venue/AddUpdate";
import AddUpdateInitiative from "./pages/Initiative/AddUpdate";
import AddUpdateShowVenues from "./pages/PerformanceVenues/AddUpdate";
import Country from "./pages/Country";
import AddUpdateCountry from "./pages/Country/AddUpdate";
import State from "./pages/State";
import AddUpdateState from "./pages/State/AddUpdate";
import City from "./pages/City";
import AddUpdateCity from "./pages/City/AddUpdate";
import Category from "./pages/Category";
import AddUpdateCategory from "./pages/Category/AddUpdate";
import Genre from "./pages/Genre";
import AddUpdateGenre from "./pages/Genre/AddUpdate";
import Shows from "./pages/Shows";
import AddUpdateShows from "./pages/Shows/AddUpdate";
import Users from "./pages/Users";
import CustomUsersForm from "./pages/Users/customUserForm";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/Projects/ProjectDetails";
import Artist from "./pages/Artist";
import ProjectArtistShow from "./pages/Projects/ProjectArtistShow";
import { ProtectedRoute } from "../utils/functions/date";
import ArtistDetails from "./pages/Projects/ArtistDetails";
import Rbac from "./pages/Rbac";
import AppFeed from "./pages/AppFeed";
import AddUpdateAppPost from "./pages/AppFeed/AddUpdate";
import ConfigGuestCount from "./pages/Config/GuestCount/GuestCount";
import ConfigVersionControl from "./pages/Config/VersionControl/VersionControl";
import ConfigQrPass from "./pages/Config/QrPass/QrPassControl";
import ConfigNotifications from "./pages/Config/Notifications/Notifications";
import ConfigOnBoarding from "./pages/Config/OnBoarding/OnBoarding";
import Homev2 from "./components/Dashboard/Homev2";

const Markup = () => {
  const allroutes = [
    /// Dashboard
    { module: "dashboard", url: "", component: <Homev2 /> },
    { module: "dashboard", url: "dashboard", component: <Homev2 /> },
    // { module: "dashboard", url: "dashboardv2", component: <Homev2 /> },
    { module: "audience", url: "audience", component: <Audience /> },
    { module: "audience", url: "audience/add", component: <CustomForm /> },
    { module: "audience", url: "audience/add-group", component: <CustomGroupForm /> },
    { module: "audience", url: "audience/edit-group", component: <CustomGroupForm /> },
    { module: "audience", url: "audience/edit", component: <CustomForm /> },
    { module: "organisation", url: "users", component: <Users /> },
    { module: "organisation", url: "users/add", component: <CustomUsersForm /> },
    { module: "organisation", url: "users/edit", component: <CustomUsersForm /> },
    { module: "abhivyakti", url: "venues", component: <Venue /> },
    { module: "abhivyakti", url: "venues/add", component: <AddUpdate /> },
    { module: "abhivyakti", url: "venues/edit", component: <AddUpdate /> },
    { module: "abhivyakti", url: "initiatives", component: <Initiative /> },
    {
      module: "abhivyakti",
      url: "initiatives/add",
      component: <AddUpdateInitiative />,
    },
    {
      module: "abhivyakti",
      url: "initiatives/edit",
      component: <AddUpdateInitiative />,
    },
    {
      module: "abhivyakti",
      url: "show-venues",
      component: <PerformanceVenues />,
    },
    {
      module: "abhivyakti",
      url: "show-venues/add",
      component: <AddUpdateShowVenues />,
    },
    {
      module: "abhivyakti",
      url: "show-venues/edit",
      component: <AddUpdateShowVenues />,
    },
    { module: "master", url: "countries", component: <Country /> },
    {
      module: "master",
      url: "countries/add",
      component: <AddUpdateCountry />,
    },
    {
      module: "master",
      url: "countries/edit",
      component: <AddUpdateCountry />,
    },
    { module: "master", url: "states", component: <State /> },
    { module: "master", url: "states/add", component: <AddUpdateState /> },
    { module: "master", url: "states/edit", component: <AddUpdateState /> },
    { module: "master", url: "cities", component: <City /> },
    { module: "master", url: "cities/add", component: <AddUpdateCity /> },
    { module: "master", url: "cities/edit", component: <AddUpdateCity /> },
    { module: "master", url: "art-form", component: <Category /> },
    {
      module: "master",
      url: "art-form/add",
      component: <AddUpdateCategory />,
    },
    {
      module: "master",
      url: "art-form/edit",
      component: <AddUpdateCategory />,
    },
    { module: "master", url: "genre", component: <Genre /> },
    { module: "master", url: "genre/add", component: <AddUpdateGenre /> },
    { module: "master", url: "genre/edit", component: <AddUpdateGenre /> },
    { module: "abhivyakti", url: "shows", component: <Shows /> },
    { module: "abhivyakti", url: "shows/add", component: <AddUpdateShows /> },
    { module: "abhivyakti", url: "shows/edit", component: <AddUpdateShows /> },
    { module: "projects", url: "projects", component: <Projects /> },
    { module: "projects", url: "projects/:id", component: <ProjectDetails /> },
    {
      module: "projects",
      url: "projects/:id/showcase",
      component: <ProjectArtistShow />,
    },
    { module: "artists", url: "artists", component: <Artist /> },
    { module: "artists", url: "artists/:id", component: <ArtistDetails /> },
    { module: "master", url: "rbac", component: <Rbac /> },
    { module: "appfeed", url: "app-feed", component: <AppFeed /> },
    { module: "appfeed", url: "app-feed/add", component: <AddUpdateAppPost /> },
    { module: "appfeed", url: "app-feed/edit", component: <AddUpdateAppPost /> },
    { module: "config", url: "config/guest-management", component: <ConfigGuestCount /> },
    { module: "config", url: "config/app-version", component: <ConfigVersionControl /> },
    { module: "config", url: "config/qr-pass", component: <ConfigQrPass /> },
    { module: "config", url: "config/notification", component: <ConfigNotifications /> },
    { module: "config", url: "config/onboarding", component: <ConfigOnBoarding /> },
    ///Redux
    { url: "todo", component: Todo },

    { url: "empty", component: <EmptyPage /> },
  ];
  // let path = window.location.pathname;
  // path = path.split("/");
  // path = path[path.length - 1];

  // let pagePath = path.split("-").includes("page");

  function NotFound() {
    const url = allroutes.map((route) => route.url);
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    if (url.indexOf(path) <= 0) {
      return <Error404 />;
    }
  }

  return (
    <>
      <Routes>
        <Route path="/page-lock-screen" element={<LockScreen />} />
        <Route path="/page-error-400" element={<Error400 />} />
        <Route path="/page-error-403" element={<Error403 />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => {
            // let allowedRoles = ["admin", "core_team"]; // default

            // if (data.url == "audience") {
            //   // Both Audience & Volunteers can only access Audience page
            //   allowedRoles = ["admin", "core_team", "volunteers"];
            // } else if (data.url === "dashboard" || data.url === "") {
            //   // Only Admin & Core Team can access dashboard
            //   allowedRoles = ["admin", "core_team"];
            // }

            return (
              <Route
                key={i}
                exact
                path={`${data.url}`}
                element={
                  <ProtectedRoute data={data}>
                    {data?.component}
                  </ProtectedRoute>
                }
              />
            );
          })}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector((state) => state.sideMenu);
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""
        }`}
    >
      <Nav />
      <div className="content-body">
        <div
          className="container-fluid"
          style={{ minHeight: window.screen.height - 45 }}
        >
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Markup;
